import {makeVar} from '@apollo/client';
import {AppFilters, UserFilters} from '../typing/local-storage';
import {ModalDisplayMode} from '../typing/modal-display';
import {CategoryModels} from '../typing/model';
import {UsedInventoryData, UsedVehicle} from '../typing/used-inventory';
import {DEFAULT_FILTERS_CONFIG} from '../utils/app-constants';

export const modelsConfigVar = makeVar<CategoryModels[]>([]);

export interface GlobalModelData {
  modelName?: string;
  year: number;
  slug?: string;
}
export const globalModelData = makeVar<GlobalModelData | undefined>(undefined);

export const DEFAULT_USER_FILTERS = {
  page: 0,
  sortBy: 'distance',
  distance: DEFAULT_FILTERS_CONFIG.distance.default,
  wasSearched: true,
};

export interface ModalsData {
  vehicle?: UsedVehicle;
  active: boolean;
  mode?: ModalDisplayMode;
  urlRedirect?: string;
  vehiclePosition?: number;
}

export const userFilters = makeVar<UserFilters>(DEFAULT_USER_FILTERS);
export const pageName = makeVar<string>('CPO Results');

export const appFilters = makeVar<AppFilters | undefined>({});
export const searchData = makeVar<UsedInventoryData | undefined>(undefined);
export const modalsData = makeVar<ModalsData>({active: false});
export const hasBeforeResults = makeVar<boolean>(false);
export const globalIsSticky = makeVar<boolean>(false);
